/* nutrient-ops theme-bundle: ns-partner v3 — installed by the LP Builder from nutrient-ops (website/ns-partner/theme). Edit the repo copy and reinstall; hand edits here are overwritten on the next install. */
/* Partner offer section (sections/ns-partner-offer.liquid): quantity steppers, the coupon "Buy now"
   cart permalink, applying the coupon when a shopper uses Add to cart instead, and the countdown.
   Add to cart itself is Booster's own add-to-cart-button on the theme's product form. */
(function (root) {
  "use strict";

  /** Seconds left -> {d, h, m, s}; never negative. */
  function countdownParts(secondsLeft) {
    var t = Math.max(0, Math.floor(Number(secondsLeft) || 0));
    return { d: Math.floor(t / 86400), h: Math.floor((t % 86400) / 3600), m: Math.floor((t % 3600) / 60), s: t % 60 };
  }

  /** A whole quantity from an input value, clamped to [1, max]. */
  function clampQty(value, max) {
    var q = Math.floor(Number(value));
    if (!isFinite(q) || q < 1) q = 1;
    var m = Math.floor(Number(max));
    if (isFinite(m) && m >= 1 && q > m) q = m;
    return q;
  }

  /** Cart permalink straight to checkout with the code applied: /cart/<variant>:<qty>?discount=<code>. */
  function buyNowHref(variantId, qty, code) {
    var href = "/cart/" + encodeURIComponent(String(variantId)) + ":" + clampQty(qty);
    return code ? href + "?discount=" + encodeURIComponent(String(code)) : href;
  }

  var api = { countdownParts: countdownParts, clampQty: clampQty, buyNowHref: buyNowHref };
  root.NSPartnerOffer = api;
  if (typeof module === "object" && module.exports) module.exports = api;

  var doc = root.document;
  if (!doc || !doc.querySelectorAll) return;

  function init(section) {
    if (section.getAttribute("data-ns-po-ready")) return;
    section.setAttribute("data-ns-po-ready", "1");
    var code = section.getAttribute("data-code") || "";
    var qty = section.querySelector("[data-ns-po-qty]");
    var buyNow = section.querySelector("[data-ns-po-buynow]");

    function syncBuyNow() {
      if (buyNow && qty) buyNow.setAttribute("href", buyNowHref(buyNow.getAttribute("data-variant"), qty.value, code));
    }
    Array.prototype.forEach.call(section.querySelectorAll("[data-ns-po-step]"), function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (!qty) return;
        qty.value = clampQty(Number(qty.value) + Number(btn.getAttribute("data-ns-po-step")), qty.getAttribute("max"));
        syncBuyNow();
      });
    });
    if (qty) qty.addEventListener("change", function () { qty.value = clampQty(qty.value, qty.getAttribute("max")); syncBuyNow(); });
    syncBuyNow();

    // Add to cart with a coupon offer: also set the store's discount cookie, so the code is already
    // applied at checkout. Best effort; the price line tells shoppers the code either way.
    if (code) {
      var atc = section.querySelector("[data-buy-button]");
      if (atc && root.fetch) {
        atc.addEventListener("click", function () {
          root.fetch("/discount/" + encodeURIComponent(code) + "?redirect=%2Fcart.js", { credentials: "same-origin" }).catch(function () {});
        });
      }
    }

    var cd = section.querySelector("[data-ns-po-ends]");
    if (cd) {
      var ends = Number(cd.getAttribute("data-ns-po-ends"));
      var cells = {};
      Array.prototype.forEach.call(cd.querySelectorAll("[data-ns-po-cd]"), function (el) { cells[el.getAttribute("data-ns-po-cd")] = el; });
      var tick = function () {
        var left = ends - Math.floor(Date.now() / 1000);
        if (left <= 0) { cd.hidden = true; return false; }
        var p = countdownParts(left);
        for (var k in p) if (cells[k]) cells[k].textContent = p[k];
        return true;
      };
      if (tick()) {
        var timer = root.setInterval(function () { if (!tick()) root.clearInterval(timer); }, 1000);
      }
    }
  }

  function initAll() { Array.prototype.forEach.call(doc.querySelectorAll("[data-ns-po]"), init); }
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  // Theme editor: sections re-render in place.
  doc.addEventListener("shopify:section:load", initAll);
})(typeof window !== "undefined" ? window : globalThis);
